module.exports = {"540531100":"浪卡子镇","540531101":"打隆镇","540531200":"张达乡","540531201":"伦布雪乡","540531202":"多却乡","540531203":"普玛江塘乡","540531204":"阿扎乡","540531205":"卡龙乡","540531206":"白地乡","540531207":"卡热乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540531.json
// module id = 2734
// module chunks = 0